import styled from '@emotion/styled/macro';
import { DateRangePicker as DateRangePickerComponent } from 'react-date-range';

export const DateRangePickerWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
`;

export const DateRangePicker = styled(DateRangePickerComponent)`
  .rdrCalendarWrapper {
    .rdrDayStartPreview,
    .rdrDayInPreview,
    .rdrDayEndPreview {
      background-color: var(--background-selected-hovered);
    }
    .rdrDateDisplayWrapper,
    .rdrDateDisplayItem,
    .rdrDayDisabled {
      background-color: ${({ theme }) => theme.bgColors.secondary};
    }
    .rdrDayHovered {
      background-color: ${({ theme }) =>
        theme.dark ? theme.input.hovered : theme.button.background};
      .rdrDayStartPreview,
      .rdrDayInPreview,
      .rdrDayEndPreview {
        background-color: ${({ theme }) =>
          theme.dark ? theme.input.hovered : theme.button.background};
      }
    }

    background-color: ${({ theme }) => theme.bgColors.primary};
    color: ${({ theme }) => theme.colors.primary};

    .rdrDayNumber {
      > span {
        color: ${({ theme }) => theme.colors.primary};
      }
    }
    .rdrDayPassive .rdrDayNumber span {
      color: ${({ theme }) => (theme.dark ? '#555' : '#d5dce0')};
    }
    .rdrNextPrevButton {
      background-color: ${({ theme }) => (theme.dark ? '#7b7d7f' : '#eff2f7')};
    }
    .rdrMonthAndYearPickers {
      select {
        color: ${({ theme }) => theme.colors.primary};
      }
    }
  }
  .rdrDefinedRangesWrapper {
    background-color: ${({ theme }) => theme.bgColors.primary};

    .rdrInputRangeInput {
      color: ${({ theme }) => theme.colors.secondary};
      background-color: ${({ theme }) => theme.input.background};
      border: 0;
      box-shadow: ${({ theme }) => theme.input.boxShadow};
      &:hover {
        color: ${({ theme }) => theme.colors.secondary};
      }
    }
    .rdrStaticRanges {
      .rdrStaticRange {
        background-color: ${({ theme }) => theme.bgColors.primary};
        border-bottom: 1px solid var(--border);
        &:hover .rdrStaticRangeLabel,
        &:focus .rdrStaticRangeLabel {
          background-color: ${({ theme }) => theme.bgColors.hovered};
        }

        .rdrStaticRangeLabel {
          color: ${({ theme }) => theme.colors.primary};
        }
      }
      .rdrStaticRangeSelected {
        background-color: var(--background-selected-hovered);
      }
    }
  }
  .rdrMonthsHorizontal {
    height: auto !important;

    -webkit-overflow-scrolling: touch;
    -webkit-transform: translateZ(0);

    ::-webkit-scrollbar {
      height: 4px;
      width: 4px;
    }

    &:hover {
      ::-webkit-scrollbar-thumb {
        visibility: visible !important;
      }
    }

    ::-webkit-scrollbar-corner {
      display: none;
    }

    ::-webkit-scrollbar-thumb {
      visibility: hidden;
      background-color: var(--background-accent-gray-subtle);
    }

    ::-webkit-scrollbar-button:end:increment,
    ::-webkit-scrollbar-button:start:decrement {
      background: #0000;
      display: none;
    }

    ::-webkit-scrollbar-track-piece:vertical:start {
      border-radius: 4px 4px 0 0;
    }

    ::-webkit-scrollbar-track-piece:vertical:end {
      border-radius: 0 0 4px 4px;
    }

    ::-webkit-scrollbar-track-piece:horizontal:start {
      border-radius: 4px 0 0 4px;
    }

    ::-webkit-scrollbar-track-piece:horizontal:end {
      border-radius: 0 4px 4px 0;
    }
  }
`;

export const DatePickerTrigger = styled.div`
  position: relative;
  height: 39px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  color: #535456;
  font-size: 14px;
  font-weight: 300;
  white-space: nowrap;
  cursor: pointer;
  padding: 0px 10px;
  border-radius: 4px;
  border-width: 2px;
  background-color: ${({ theme }) =>
    theme.name === 'dark' ? '#282d34' : '#f6F6f7'};
  box-shadow: ${({ theme }) => theme.input.boxShadow};
  margin: 0px;

  &:hover {
    background-color: ${({ theme }) => theme.input.hovered};
    box-shadow: ${({ theme }) => theme.input.boxShadowHovered};
  }

  &:focus {
    outline: none;
    border-color: rgb(38, 132, 255);
    box-shadow: ${({ theme }) => theme.input.boxShadowHovered};
    cursor: pointer;
  }
`;

DatePickerTrigger.displayName = 'DatePickerTrigger';

export const DatePickerCalendarIcon = styled.img`
  margin-left: 5px;
  height: 16px;
`;

export const MonthTrigger = styled.div`
  display: flex;
  font-weight: 500;
  font-size: 16px;
  line-height: 32px;
  cursor: pointer;
  padding-left: 6px;
`;

export const MonthTriggerIcon = styled.div`
  display: flex;
  align-items: center;
  margin-left: 8px;
`;

export const DateRangePickerStory = styled.div`
  display: flex;
  justify-content: flex-start;
`;
